<template>
  <div class="donate-choice-wrapper" :class="wrapperClasses">
    <product-donate-type :value="$store.state.donateType" :product="product" v-if="showDonateType" @input="onDonateTypeChange"/>

    <!--<div class="block-title">{{ title }}</div>-->

    <div class="row px-2 justify-content-center mb-2">
      <div class="col-4 col-sm-4 col-md-4 py-1 px-1" v-for="(choice, cIdx) in cleanChoices">
        <div
          class="donate-item py-2 px-1 py-md-3 h-100 text-center radius"
          :class="[donorItemClasses, {'active' : !isCustomAmount && (amount === choice && amount > 0)}]"
          @click="setAmount(choice)"
        >
          <div class="d-flex h-100 align-items-center flex-wrap justify-content-center">
            <label class="m-0 w-100">
              <input type="radio" name="amount" v-model.number="amount" :value="choice" @input="onAmountChange"
                     @click="onAmountChange"/> {{ choice | comma }} บาท
            </label>
            <div class="small" v-if="choiceDescriptions[cIdx]">{{choiceDescriptions[cIdx]}}</div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 px-1">
        <div
          class="donate-item--other pt-2 pt-md-3 text-left radius h-100"
          @click="isCustomAmount = true; $refs.inputCustomAmount.focus()"
          :class="[donorItemClasses, {'active' : isCustomAmount}]"
        >
          <div class="d-flex h-100 align-items-center flex-column justify-content-between item-other">
            <label class="other-item d-none">
              <input name="amount" type="radio" v-model="isCustomAmount" :value="true"/> ระบุจำนวน
            </label>
            <input
              type="number"
              class="form__text form__text--line text-left"
              autocomplete="off"
              placeholder="ระบุจำนวน"
              v-model.number="customAmount"
              onkeydown="if(event.key==='.'){event.preventDefault();}"  
              oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
              @focus="isCustomAmount = true"
              ref="inputCustomAmount"/> <span class="prefix">บาท</span>
              
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert--error" v-show="$v.$errors['customAmount'].minimum">
      จำนวนเงินขั้นต่ำ {{ product.originalPrice }} บาท
    </div>

    <product-duration
      :product="product"
      :donate-type="effectiveDonateType"
      :value="totalCount"
      @input="onTotalCountChange"
    />
  </div>
</template>

<script>
  import ProductDonateType from '@/components/ProductDonateType'
  import ProductDuration from '@/components/ProductDuration'

  export default {
    name: 'ProductDonateChoice',

    components: {
      ProductDonateType,
      ProductDuration
    },

    props: {
      title: {
        type: String,
        default: 'เลือกจำนวนเงิน'
      },
      product: {
        type: Object,
        required: true
      },
      choices: {
        type: Array,
        required: true
      },
      choiceDescriptions: {
        type: Array,
        required: false,
        default: () => ([])
      },
      defaultAmount: {
        type: Number,
        default: 500
      },
      minimum: {
        type: Number,
        default: 100
      },
      wrapperClasses: {
        type: String,
        default: ''
      },
      classes: {
        type: String,
        default: ''
      },
      showDonateType: {
        type: Boolean,
        default: true
      }
    },

    data () {
      return {
        customAmount: '',
        isCustomAmount: false,
        amount: this.defaultAmount,
        $v: null
      }
    },

    created () {
      this.initValidator()
    },

    computed: {
      donorItemClasses () {
        return this.classes
      },
      cleanChoices () {
        return this.choices || []
      },
      // Phase 10: match Payment.vue durationDonateType — forceDaily overrides monthly only (D-12).
      // For onetime, return as-is so ProductDuration stays hidden (no duration concept).
      effectiveDonateType () {
        const donateType = this.$store.state.donateType
        if (donateType === 'monthly' && this.$store.state.forceDaily) return 'daily'
        return donateType
      },
      totalCount () {
        return this.$store.state.totalCount || 0
      }
    },

    methods: {
      initValidator () {
        this.$v = this.$validator.init(this, {
          customAmount: { minimum: this.product.originalPrice, dependOn: { field: 'isCustomAmount', value: true } }
        })
      },

      validate () {
        this.$forceUpdate()
        if (!this.$v.validate()) {
          this.$utils.scrollToFirstErrors()
          return false
        }
        return true
      },

      emit (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      },

      getPrice () {
        if (this.isCustomAmount) {
          return parseInt(this.customAmount, 10) || 0
        }
        return this.amount
      },

      setAmount (choice) {
        this.isCustomAmount = false
        this.amount = choice
        this.$utils.gaTrackViewProduct(this.product, this.amount)
        this.$utils.fbTrackViewContent(this.product, this.amount)
      },

      // events.
      onAmountChange (evt) {
        this.isCustomAmount = false
      },

      onTotalCountChange (v) {
        this.$store.commit('setTotalCount', v)
      },

      onDonateTypeChange (type) {
        this.$store.dispatch('setDonateType', type)
      }
    },

    watch: {
      defaultAmount: function (v) {
        if (this.isCustomAmount) {
          return
        }
        this.amount = parseInt(v, 10) || 0
      },
      '$store.state.donateType': function (donateType) {
        this.amount = this.defaultAmount
        this.onAmountChange()
      }
    }
  }
</script>

<style scoped lang="scss">
  .donate-choice-wrapper {
    max-width: 400px;
    margin: 0 auto;
    label input[type=radio] {
      position: absolute;
      clip: rect(0, 0, 0, 0);
      pointer-events: none;
    }

    .block-title {
      text-align: center;
      margin: 1.5rem 0;
      font-size: 1.5rem;
      font-family: 'Wittaya-Medium';
    }
  }

  .product-donate-choice {
    &.row {
      margin-left: 0;
      margin-right: 0;

      .donate-item {
        padding-left: 5px;
        padding-right: 5px;
      }
    }

  }

  .donate-item {
    background: transparent;
    color: #153050;
    border: 1px solid #153050;
    font-size: 1.1rem;
    font-family: 'Wittaya-Medium';
    cursor: pointer;
    user-select: none;
    box-shadow: 0 2px 4px 0 rgba($color: #000000, $alpha: 0.2);
    border-radius: 6px;
    min-height: 65px;
    line-height: 1.2;
    .small {
      margin-top: 0.5rem;
      line-height: 1.5;
      font-size: 0.75rem;
      font-family: 'Wittaya-Light';
    }
    @media only screen and (min-width: 768px) {
      
      font-size: 1.35rem;
      .small {
         font-size: 0.85rem;
      }
    }
    label {
      cursor: pointer;
    }
    .form__text--line {
      border-radius: 4px;
      margin-bottom: 0;
      padding: 0.5rem 1rem !important;
      font-family: 'Wittaya-Medium';
      color: #153050;
      
    }
    &--other {
      .other-item {
        margin-bottom: 0;
        font-size: 1rem;
      }
      .item-other {
        position: relative;
        font-size: 1.25rem;
        input[type=number] {
          border-radius: 6px;
          background-color: #f9f9f9;
          border: 1px solid #979797;
        }
        input::placeholder {
          color: #999999
        }
        input:focus,
        input:hover,
        input:active {
          font-family: 'Wittaya-Medium';
          background-color: white;
          border-color: #1972D9;
          color: #38AB49;
          font-size: 1.35rem;
        }
        span.prefix {
          font-family: 'Wittaya-Medium';
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translate(0,-50%);
        }
        @media only screen and (min-width: 768px) {
          font-size: 1.35rem;
          input:focus,
          input:hover,
          input:active {
            // font-size: 1.5rem;
          }
        }
      }
    }
    
  }
  

  .donate-item.active {
    background: #1E416D;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// ProductDonateChoice.vue?20bec6ed